import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { Link } from "react-router-dom";
import { Filters } from "./components"
import api from "services/api";

import { Access } from "common";
import { Page, Panel, Loading, Breadcrumbs, Pagination } from "components";

const FILTER_DEFAULT_VALUES = {
  status_value: {
    value: null,
    label: "Selecionar"
  },
  title_value: {
    value: null,
    label: ""
  }
};

class List extends Component {
  state = {
    campaigns: [],
    total: 0,
    page: 1,
    loading: false,
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Campanhas Comerciais", to: "" },
    ],
    filter: {
      ...FILTER_DEFAULT_VALUES
    }
  };

  componentDidMount() {
    const { location } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;
    this.loadData(page);
  }

  componentDidUpdate(oldProps) {
    const { location } = this.props;
    const { filter } = this.state;
    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      this.loadData(queryString.parse(location.search).page, filter);
    }
  }

  handleChangeFilter = (name, value) => {
    const { filter } = this.state;
    const { location } = this.props;

    this.setState({ filter: { ...filter, [name]: value } }, () => {
      const { filter } = this.state;
      this.loadData(queryString.parse(location.search).page, filter);
    });
  };

  handleCleanFilter = (e) => {
    e.preventDefault();

    const { location } = this.props;

    const defaultFilters = {
      filter: {
        ...FILTER_DEFAULT_VALUES
      },
    };

    this.setState(defaultFilters, () => {
      const { filter } = this.state;
      this.loadData(queryString.parse(location.search).page, filter);
    });
  };


  loadData = async (page = 1, filter = FILTER_DEFAULT_VALUES) => {

    const formattedFilter = {
      status_value: filter.status_value.value,
      title_value: filter.title_value.value,
    }

    try {
      this.setState({ loading: true });

      const response = await api.get("experience/v2/commercial_campaigns" , {
        params: {
          page,
          per: 25,
          ...formattedFilter
        }
      });

      const { data, meta } = response.data;

      this.setState({
        campaigns: data,
        total: meta.total_count,
        page: meta.current_page,
      });
    } catch (err) {
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { breadcrumbs, campaigns, loading, total, page, filter } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Campanhas Comerciais</Page.Title>

        <Panel className="panel-list">

          {Access.hasPermissions("edit-benefits") && (
            <Link
              to="/benefits/campaign/create"
              className="button-add margin-bottom-20"
            >
              Adicionar Campanha
            </Link>
          )}

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
          />

          {!campaigns.length && loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>título</th>
                    <th>descrição</th>
                    <th>ativo</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!campaigns.length && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {campaigns.map((campaign) => (
                    <tr key={String(campaign.id)}>
                      <td>{campaign.attributes.title}</td>
                      <td>{campaign.attributes.description}</td>
                      <td>{campaign.attributes.status_value ? 'Sim' : 'Não'}</td>
                      <td className="text-right">
                        {Access.hasPermissions("edit-benefits") && (
                          <Link
                            to={`/benefits/campaign/${campaign.id}/edit`}
                            className="button-icon"
                          >
                            <span className="glyph glyph-eye" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={page}
                total={total}
                per={25}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

export default List;
